import { all, call, put, take } from 'redux-saga/effects';
import { get } from 'lodash';

import { LOAD_STAFF_PRACTITIONER_LIST } from '../type';
import {
  loadStaffPractitionerListSuccessAction,
  loadStaffPractitionerListErrorAction,
} from '../action';
import { practitionerService } from 'services';

function* loadPractitioners() {
  while (1) {
    const action = yield take(LOAD_STAFF_PRACTITIONER_LIST);
    try {
      const callback = get(action, 'payload.callback');

      const response = yield call(
        practitionerService.getStaffPractitioner,
        action.payload.options,
      );

      callback && callback(response);

      yield put(loadStaffPractitionerListSuccessAction(response));
    } catch (error) {
      yield put(loadStaffPractitionerListErrorAction(error));
    }
  }
}

export default function* rootSaga() {
  yield all([loadPractitioners()]);
}
